import api from '@/api';

import {
  CompanyStockConfiguration,
  CompanyStockConfigurationCostItemCreateRequest,
  CompanyStockConfigurationFixedCostCreateRequest,
  CompanyStockConfigurationProfitMarginCreateRequest,
  PartConfigurationProfile,
  UpdateCompanyStockConfigurationRequest,
  UpdatePartConfigurationProfileRequest,
} from './Configuration.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/configurations`;

export async function getCompanyStockConfiguration(
  companyId?: number,
): Promise<CompanyStockConfiguration> {
  const result = (await api.get(
    `${CONTROLLER_URL}/companies/${companyId}`,
    null,
  )) as unknown;

  return result as CompanyStockConfiguration;
}

export async function updateCompanyStockConfiguration(
  obj: UpdateCompanyStockConfigurationRequest,
): Promise<CompanyStockConfiguration> {
  const result = (await api.put(
    `${CONTROLLER_URL}/companies/${obj.companyId}`,
    obj,
    null,
  )) as unknown;

  return result as CompanyStockConfiguration;
}

export async function getPartConfigurationProfile(): Promise<PartConfigurationProfile> {
  const result = (await api.get(`${CONTROLLER_URL}/profiles`, null)) as unknown;

  return result as PartConfigurationProfile;
}

export async function updatePartConfigurationProfile(
  obj: UpdatePartConfigurationProfileRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/profiles`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function createCompanyStockConfigurationFields(
  obj: CompanyStockConfigurationCostItemCreateRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/companies/${obj.companyId}/fields`,
    obj,
    null,
  )) as unknown;

  return result as CompanyStockConfiguration;
}

export async function createCompanyStockConfigurationFixedCost(
  obj: CompanyStockConfigurationFixedCostCreateRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/companies/${obj.companyId}/fixed-cost`,
    obj,
    null,
  )) as unknown;

  return result as CompanyStockConfiguration;
}

export async function createCompanyStockConfigurationProfitMargin(
  obj: CompanyStockConfigurationProfitMarginCreateRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/companies/${obj.companyId}/profit-margin`,
    obj,
    null,
  )) as unknown;

  return result as CompanyStockConfiguration;
}
